import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import EnterprisePageWrapper from 'bundles/unified-description-page-common/pages/enterprise/EnterprisePageWrapper';

const EnterpriseCoursePageRoot = loadOnRoute(
  () => import('bundles/unified-description-page-common/pages/enterprise/course/EnterpriseCoursePageRoot')
);
const EnterpriseSpecializationPageRoot = loadOnRoute(
  () =>
    import('bundles/unified-description-page-common/pages/enterprise/specialization/EnterpriseSpecializationPageRoot')
);
const EnterpriseProfessionalCertificatePageRoot = loadOnRoute(
  () =>
    import(
      'bundles/unified-description-page-common/pages/enterprise/professional-certificate/EnterpriseProfessionalCertificatePageRoot'
    )
);
const EnterpriseProjectPageRoot = loadOnRoute(
  () => import('bundles/unified-description-page-common/pages/enterprise/project/EnterpriseProjectPageRoot')
);

export default (
  <Route>
    <CourseraRoute
      name="enterprise"
      path="/programs/:programSlug"
      component={EnterprisePageWrapper}
      handle={{
        tracking: {
          data: (params) => ({
            page: { segment: 'enterprise' },
            enterprise: {
              ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
            },
          }),
        },
      }}
    >
      <CourseraRoute
        name="enterprise-course"
        path="learn/:productSlug"
        getComponent={EnterpriseCoursePageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_course',
              },
            }),
          },
        }}
      />
      <CourseraRoute
        name="enterprise-specialization"
        path="specializations/:productSlug"
        getComponent={EnterpriseSpecializationPageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_s12n',
              },
            }),
          },
        }}
      />
      <CourseraRoute
        name="enterprise-professional-certificate"
        path="professional-certificates/:productSlug"
        getComponent={EnterpriseProfessionalCertificatePageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_professional_cert',
              },
            }),
          },
        }}
      />
      <CourseraRoute
        name="enterprise-project"
        path="projects/:productSlug"
        getComponent={EnterpriseProjectPageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_project',
              },
            }),
          },
        }}
      />
    </CourseraRoute>
    <Route path="*" component={NotFound} />
  </Route>
);
